'use strict';

export default function (klaviyoData) {
	if (typeof Array.prototype.unique !== 'function') {
		Array.prototype.unique = function () {
			var a = [];
			var l = this.length;

			for (var i = 0; i < l; i++) {
				if (a.indexOf(this[i]) === -1) {
					a.push(this[i]);
				}
			}

			return a;
		};
	}

	_learnq.push([
		'track',
		'Added to Cart',
		{
			$value: klaviyoData.value,
			AddedItemProductName: klaviyoData.AddedItemProductName,
			AddedItem_Brand: klaviyoData.AddedItem_Brand,
			AddedItem_Categories: klaviyoData.AddedItem_Categories,
			AddedItem_ImageURL: klaviyoData.AddedItem_ImageURL,
			AddedItem_Price: klaviyoData.AddedItem_Price,
			AddedItem_Quantity: klaviyoData.AddedItem_Quantity,
			AddedItem_SKU: klaviyoData.AddedItem_SKU,
			AddedItem_URL: klaviyoData.AddedItem_URL,
			CheckoutURL: klaviyoData.CheckoutURL,
			ItemNames: Array.isArray(klaviyoData.ItemNames) ? klaviyoData.ItemNames.unique() : [],
			Items: klaviyoData.Items
		}
	]);
}
